var app = angular.module('directives.autocomplete', []);

require('./directives/autocomplete.directive.js');
require('./stylesheet/style.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/autocomplete/index.js
 ** module id = 129
 ** module chunks = 1
 **/